/**
 * Client Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.2.9
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ManagementClientSubscriptionResponse } from './managementClientSubscriptionResponse';
import { ManagementResellerResponse } from './managementResellerResponse';

export interface ManagementClientResponse { 
    id: string;
    name?: string;
    description?: string;
    taxId?: string;
    showTags?: boolean;
    showSentiment?: boolean;
    newAnalytics?: boolean;
    lang?: ManagementClientResponse.LangEnum;
    foreignCountry?: boolean;
    lastClippingReportSentAt?: Date;
    lastBiReportSentAt?: Date;
    subscriptions?: Array<ManagementClientSubscriptionResponse>;
    reseller?: ManagementResellerResponse;
    pendingTagsSubscriptionsJson?: string;
    pendingInvoiceJson?: string;
    pendingPaymentOption?: string;
}
export namespace ManagementClientResponse {
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}